import { render, staticRenderFns } from "./merge-history-table.vue?vue&type=template&id=c7830276&scoped=true"
import script from "./merge-history-table.vue?vue&type=script&lang=js"
export * from "./merge-history-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7830276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7830276')) {
      api.createRecord('c7830276', component.options)
    } else {
      api.reload('c7830276', component.options)
    }
    module.hot.accept("./merge-history-table.vue?vue&type=template&id=c7830276&scoped=true", function () {
      api.rerender('c7830276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/merge-history/merge-history-table.vue"
export default component.exports